<template>
  <span :style="wrapperStyle" class="form-password-fields">
    <label class="form-field-label" :for="uniqueTitle">{{ fieldLabel || 'Password' }}</label>
    <b-form-input
      :id="uniqueTitle"
      :name="uniqueTitle"
      type="password"
      autocomplete="new-password"
      :placeholder="placeholder || undefined"
      :readonly="isReadonly"
      :aria-describedby="describedBy"
      :class="{ 'form-field-readonly': isReadonly }"
      @input="onInput"
    />
    <label class="form-field-label" :for="confirmId">Confirm {{ fieldLabel || 'password' }}</label>
    <b-form-input
      :id="confirmId"
      :name="`${uniqueTitle}_confirm`"
      type="password"
      autocomplete="new-password"
      :readonly="isReadonly"
      :aria-describedby="describedBy"
      :class="{ 'form-field-readonly': isReadonly }"
    />
  </span>
</template>

<script>
import { inject, computed } from 'vue'
import { formattingToStyle } from '../../lib/client-rule-evaluator'

export default {
  props: ['placeholder', 'uniqueTitle', 'fieldLabel', 'description'],
  setup (props) {

    const formFormatting = inject('formFormatting', null)
    const formReadonly = inject('formReadonly', null)
    const updateFormValue = inject('updateFormValue', null)

    const wrapperStyle = computed(() => {
      if (!formFormatting || !props.uniqueTitle) return {}
      const fmt = formFormatting[props.uniqueTitle]
      return fmt ? formattingToStyle(fmt) : {}
    })

    const isReadonly = computed(() => {
      if (!formReadonly || !props.uniqueTitle) return false
      return !!formReadonly[props.uniqueTitle]
    })

    const confirmId = computed(() => `${props.uniqueTitle}_confirm`)

    const describedBy = computed(() => {
      return props.description ? `${props.uniqueTitle}-description` : undefined
    })

    return { formFormatting, formReadonly, updateFormValue, wrapperStyle, isReadonly, confirmId, describedBy }
  },
  methods: {
    onInput (value) {
      if (this.updateFormValue) {
        this.updateFormValue(this.uniqueTitle, value)
      }
    }
  }
}
</script>

<style>
.form-password-fields {
  display: block;
  text-align: left;
}
.form-password-fields .form-field-label {
  margin-top: 1.5rem;
}
.form-password-fields .form-field-label:first-child {
  margin-top: 0;
}
</style>
